import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import useNavMarker from './useNavMarker';
import useNavMarkerVisibility from './useNavMarkerVisibility';
import RhumbContext from './internal/RhumbContext';

const NavMarkerImpl = ({
  name
}) => {
  const ref = useRef(null);
  const context = useContext(RhumbContext);
  useNavMarker(name);
  useNavMarkerVisibility(name, ref);

  if (context && context.trackVisibility) {
    return /*#__PURE__*/_jsx("div", {
      "aria-hidden": true,
      ref: ref
    });
  }

  return null;
};

if (process.env.NODE_ENV !== 'production') {
  NavMarkerImpl.propTypes = {
    name: PropTypes.string.isRequired
  };
}

const NavMarker = ({
  children,
  name
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(NavMarkerImpl, {
    name: name
  }), children]
});

if (process.env.NODE_ENV !== 'production') {
  NavMarker.propTypes = {
    name: PropTypes.string.isRequired,
    children: PropTypes.node
  };
}

export default NavMarker;